import { getReportBreadcrumb } from '@/lib/utils/breadcrumbs'
import { createFileRoute } from '@tanstack/react-router'
import { ReportDetailsEmbed } from '../-components/ReportDetailsEmbed'

export const Route = createFileRoute('/_auth/_modules/_app/reports/ecc/$reportId')({
  component: ReportDetails,
  loader: async ({ params: { reportId } }) => {
    const crumb = await getReportBreadcrumb(reportId)
    return { crumb }
  },
})

function ReportDetails() {
  const { reportId } = Route.useParams()

  return <ReportDetailsEmbed reportId={reportId} />
}
